import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const styles = (theme) => ({
  root: {
  },
  content: {
    width: '100%',
  },
  previousButton: {
    marginRight: theme.spacing(3),
  },
  iconStyle: {
    fill: theme.palette.facet.red,
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
  },
  fields: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  matchPercentage: {
  },
  match: {
  },
});

const getMatchLabel = index => {
  switch (index) {
    case 0: return 'First Match';
    case 1: return 'Second Match';
    case 2: return 'Third Match';
    default: return `${index + 1} Match`;
  }
};
const MatchLayout = ({
  className,
  classes,
  index,
  isRemovable,
  onRemove,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box p={1} className={classes.title}>
        <Typography variant="h6" component="p">
          {getMatchLabel(index)}
        </Typography>
        {isRemovable && (
          <IconButton
            icon={DeleteOutlineIcon}
            color="red"
            className={classes.iconStyle}
            onClick={() => {
              onRemove(index);
            }}
          />
        )}
      </Box>
      <Box className={classes.fields}>
        <MetaControlField
          className={classes.matchPercentage}
          attr={'employerMatchLevelPercentage'}
        />
        <Box py={3} px={1} component={Typography} variant="body1">
          of
        </Box>
        <MetaControlField
          className={classes.match}
          attr={'employerMatchPercentage'}
        />
      </Box>
    </Box>
  );
};

MatchLayout.defaultProps = {
  className: '',
};

MatchLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isRemovable: PropTypes.bool.isRequired,
};

export default withStyles(styles)(MatchLayout);
